var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.isUsserLogged)?_c('app-header'):_vm._e(),_c('v-main',[_c('router-view')],1),(_vm.isUsserLogged)?_c('app-footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }